import type { ComponentType, FC } from 'react';
import { NodeDefault, NodeEnum } from '../types';
import NlpExtractNodeDefault from './nlp-extraction/default';
import NlpExtractNode from './nlp-extraction/node';
import NlpExtractPanel from './nlp-extraction/panel';
import SemanticRulesExtractionNodeDefault from './semantic-rules-extraction/default';
import SemanticRulesExtractionNode from './semantic-rules-extraction/node';
import SemanticRulesExtractionPanel from './semantic-rules-extraction/panel';
import StartNodeDefault from './start/default';
import StartNode from './start/node';
import TableExtractionNodeDefault from './table-extraction/default';
import TableExtractionNode from './table-extraction/node';
import TableExtractionPanel from './table-extraction/panel';

import HandWritingExtractionNodeDefault from './handwritting/default';
import HandWritingExtractionNode from './handwritting/node';
import HandWritingExtractionPanel from './handwritting/panel';

import SealNodeDefault from './seal/default';
import SealNode from './seal/node';
import SealNodePanel from './seal/panel';

import LargeModelExtractionNodeDefault from './llm/default';
import LargeModelExtractionNode from './llm/node';
import LargeModelExtractionPanel from './llm/panel';

import HandWritingExtractionNodeIcon from './handwritting/icon';
import NlpNodeIcon from './nlp-extraction/icon';
import SealNodeIcon from './seal/icon';
import SemanticRulesExtractionNodeIcon from './semantic-rules-extraction/icon';
import StartNodeIcon from './start/icon';
import TableExtractionNodeIcon from './table-extraction/icon';
import LargeModelExtractionNodeIcon from './llm/icon';

export const NodeComponentMap: Record<string, ComponentType<any>> = {
  [NodeEnum.Start]: StartNode,
  [NodeEnum.NlpExtract]: NlpExtractNode,
  [NodeEnum.SemanticRulesExtraction]: SemanticRulesExtractionNode,
  [NodeEnum.TableExtraction]: TableExtractionNode,
  [NodeEnum.HandWritingExtraction]: HandWritingExtractionNode,
  [NodeEnum.SealExtraction]: SealNode,
  [NodeEnum.LargeModelExtraction]: LargeModelExtractionNode,
};

export const PanelComponentMap: Record<string, ComponentType<any>> = {
  [NodeEnum.NlpExtract]: NlpExtractPanel,
  [NodeEnum.SemanticRulesExtraction]: SemanticRulesExtractionPanel,
  [NodeEnum.TableExtraction]: TableExtractionPanel,
  [NodeEnum.HandWritingExtraction]: HandWritingExtractionPanel,
  [NodeEnum.SealExtraction]: SealNodePanel,
  [NodeEnum.LargeModelExtraction]: LargeModelExtractionPanel,
};

export const NODES_EXTRA_DATA = {
  [NodeEnum.Start]: StartNodeDefault,
  [NodeEnum.NlpExtract]: NlpExtractNodeDefault,
  [NodeEnum.SemanticRulesExtraction]: SemanticRulesExtractionNodeDefault,
  [NodeEnum.TableExtraction]: TableExtractionNodeDefault,
  [NodeEnum.HandWritingExtraction]: HandWritingExtractionNodeDefault,
  [NodeEnum.SealExtraction]: SealNodeDefault,
  [NodeEnum.LargeModelExtraction]: LargeModelExtractionNodeDefault,
};

export const NODE_ICONS: Record<NodeEnum, FC> = {
  [NodeEnum.Start]: StartNodeIcon,
  [NodeEnum.NlpExtract]: NlpNodeIcon,
  [NodeEnum.SemanticRulesExtraction]: SemanticRulesExtractionNodeIcon,
  [NodeEnum.TableExtraction]: TableExtractionNodeIcon,
  [NodeEnum.HandWritingExtraction]: HandWritingExtractionNodeIcon,
  [NodeEnum.SealExtraction]: SealNodeIcon,
  [NodeEnum.LargeModelExtraction]: LargeModelExtractionNodeIcon,
};

export const CUSTOM_NODE_TYPE = 'custom';
